<section 
  class="content-layout" 
  [brightsideWebFb]="{ event_name: 'survey_thank_you' }"  
>
  <bw-action-article-legacy>
    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <img src="../assets/survey-thank-you.svg" alt="survey_thank_you" class="mb-md" />
          <p title-medium class="mb-sm">{{ 'SURVEY_THANK_YOU_TITLE' | translate }}</p>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="left" style="max-width: 432px;">
              {{ 'SURVEY_THANK_YOU_DESC' | translate }}
            </p>
          </typography-legacy>
        </div>
      </div>
    </div>

    <div footer-actions>
      <button        
        bw-button-legacy
        type="submit"
        [brightsideWebFb]="{ event_name: 'survey_thank_you' }"
        (click)="handleSurveyDone()"
      >
        {{ 'SURVEY_THANK_YOU_CTA' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>
